export default __webpack_public_path__ + "static/media/enigma.53a21093.png";